<template>
  <v-row>
		<v-dialog v-model="showDialog" persistent max-width="350px" style="z-index:20099;">
			<v-form ref="form">
				<v-card>
					<v-card-title class="px-2 py-0">
						<v-col cols="12" class="d-flex justify-space-between align-center">							
							<span style="font-size: 20px;">
								{{ $t('wkt.client.common.dialog.select-date.title') }}
							</span>
							<!--<v-btn icon @click="showDialog=false">
								<v-icon>mdi-close</v-icon>
							</v-btn>-->
						</v-col>
					</v-card-title>
					<!--<v-divider></v-divider>-->
					<v-card-text class="pb-0">
						<v-row>
							<v-col cols="6">
								<v-dialog
									ref="dialog1"
									v-model="modal1"
									:return-value.sync="date"
									persistent
									width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="dateFormatted"
											:rules="[validationRules.required]"
											:label="$t('wkt.client.common.dialog.select-date.date')"
											prepend-icon="event" 
											readonly
											v-bind="attrs"
											v-on="on" 
											@blur="date = parseDate(dateFormatted)" />
									</template>
									<v-date-picker 
										v-if="modal1"
										v-model="date"
										:first-day-of-week="1" 
										:locale="$i18n.locale"
										:min="minDate"
										color="#185EA9"
										no-title
										scrollable>
										<v-spacer></v-spacer>
										<v-btn color="#185EA9" text style="font-size: 0.9em; font-weight: 400;" @click="$refs.dialog1.save(date)">
											{{ $t('wkt.client.common.dialog-buttons.ok') }}
										</v-btn>                                            
										<v-btn text style="font-size: 0.9em; font-weight: 400;" @click="modal1=false">
											{{ $t('wkt.client.common.dialog-buttons.cancel') }}
										</v-btn>                                            
									</v-date-picker>
								</v-dialog>
							</v-col>
							<v-col cols="6">
								<v-dialog
									ref="dialog2"
									v-model="modal2"
									:return-value.sync="time"
									persistent
									width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="time"
											:rules="[validationRules.required]"
											:label="$t('wkt.client.common.dialog.select-date.time')"
											prepend-icon="alarm"
											readonly
											v-bind="attrs"
											v-on="on" />
									</template>
									<v-time-picker 
										v-if="modal2" 
										v-model="time" 
										ampm-in-title
										format="24hr"
										no-title
										scrollable 
										color="#185EA9"
										full-width>
										<v-spacer></v-spacer>
										<v-btn color="#185EA9" text style="font-size: 0.9em; font-weight: 400;" @click="$refs.dialog2.save(time)">
											{{ $t('wkt.client.common.dialog-buttons.ok') }}
										</v-btn>
										<v-btn text style="font-size: 0.9em; font-weight: 400;" @click="modal2=false">
											{{ $t('wkt.client.common.dialog-buttons.cancel') }}
										</v-btn>
									</v-time-picker>
								</v-dialog>
							</v-col>
						</v-row>
					</v-card-text>
					<!--<v-divider></v-divider>-->
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="#185EA9" text @click="doOk()" style="font-size: 0.9em; font-weight: 400;">
							{{ $t('wkt.client.common.dialog-buttons.ok') }}
						</v-btn>
						<v-btn text	@click="showDialog = false" style="font-size: 0.9em; font-weight: 400;">
							{{ $t('wkt.client.common.dialog-buttons.cancel') }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>
	</v-row>
</template>

<script>
import BaseModule from './BaseModule.js'

export default {
  name: 'SelectDatesDialog',
  mixins: [ BaseModule ],
  data() {
		return { 
			modal1: false,
			modal2: false,
			minDate: null,
			date: null,
			dateFormatted: null,
			time: null,
			showDialog: false,
			msgCbOk: null,
		}
  },
  methods: {
		isVisible() {
			return this.showDialog;
		},
		close() {
			this.showDialog = false; 
		},
		open(date, minDate, msgCbOk) {
			if (minDate) {
				this.minDate = new Date(this.fixISODate(minDate)).toISOString();
			}

			if (this.$refs.form) {
				this.$refs.form.resetValidation();
			}

			if (!date) {
				date = new Date();
				date.setHours(12);
				date.setMinutes(0);
				date.setSeconds(0);
			}// else {
				date = this.formatLongDateTime(date);
			//}

			this.date = this.parseDate(date.split(', ')[0]);
			this.dateFormatted = this.formatDate(this.date);
			this.time = this.parseTime(date.split(' ')[1]);
			
			this.showDialog = true;
			this.msgCbOk = msgCbOk;
		},
		doOk: function() {
			if (!this.$refs.form.validate()) {
				return;
			}

			this.showDialog = false;

			if (this.msgCbOk) {
				this.msgCbOk(new Date(`${this.date}T${this.time}:00`));
			}
		},
		formatDate (date) {
			if (!date) return null;

			const [year, month, day] = date.split('-');

			return `${day}/${month}/${year}`;
		},
		parseDate (date) {
			if (!date) return null;

			const [day, month, year] = date.split('/');

			return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
		},
		parseTime (time) {
			if (!time) return null;

			// eslint-disable-next-line no-unused-vars
			const [hours, minutes, seconds] = time.split(':');

			return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
		}
  },
  watch: {
    date () {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
}
</script>